import React, { Fragment, useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Editor } from "@tinymce/tinymce-react";
import { CircularProgress } from "@mui/material";
import * as constants from "../../../utils/Constants";

const PostJob = () => {
  const history = useHistory();
  const CustomClearText = () => "clear all";
  const [isSpin, setIsSpin] = useState(false);
  const loggedInUser = JSON.parse(localStorage.getItem("user"));

  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
    );
  };

  const clearFilter = () => {
    window.location.reload();
  };

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "blue" : "black",
  });

  const handleDownloadResume = (jobDescriptionFileName) => {
    if (jobDescriptionFileName) {
      var url = `${constants.DownloadAttachmentUrl}/${jobDescriptionFileName}`;
      // window.location.href = url;
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.blob())
        .then((response) => {
          var fileDownload = require("js-file-download");
          fileDownload(response, `${state?.jobDescriptionFileName}`);
        });
    }
  };

  const handleDownloadEmail = (fileName) => {
    if (fileName) {
      var url = `${constants.DownloadAttachmentUrlEmail}/${fileName}`;
      // window.location.href = url;
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.blob())
        .then((response) => {
          var fileDownload = require("js-file-download");
          fileDownload(response, `${state?.emailReceivedFileName}`);
        });
    }
  };

  function changeEndDate() {
    var date = state?.jobEndDate?.split("/");
    if (date) {
      if (parseInt(date[1]) <= 12) {
        endDate = new Date(date[2], date[1] - 1, date[0]).toLocaleDateString(
          "en-US"
        );
      } else {
        endDate = new Date(date[2], date[0] - 1, date[1]).toLocaleDateString(
          "en-US"
        );
      }
    }
  }

  function changeEmailDate(param) {
    var date = param?.split("/");
    if (date) {
      if (parseInt(date[1]) <= 12) {
        emailDate = new Date(date[2], date[1] - 1, date[0]).toLocaleDateString(
          "en-US"
        );
      } else {
        emailDate = new Date(date[2], date[0] - 1, date[1]).toLocaleDateString(
          "en-US"
        );
      }
      return emailDate;
    }
  }

  function changeKeySkills() {
    for (var i = 0; i < state?.keySkills?.length; i++) {
      existingKeySkill.push({
        label: state?.keySkills[i],
        value: state?.keySkills[i],
      });
    }
  }

  function changeQualifications() {
    for (var i = 0; i < state?.qualification?.length; i++) {
      existingQualification.push({
        label: state.qualification[i],
        value: state.qualification[i],
      });
    }
  }

  function changeIndustry() {
    for (var i = 0; i < state?.industries?.length; i++) {
      existingIndustry.push({
        label: state?.industries[i],
        value: state?.industries[i],
      });
    }
  }

  function changePreferredLocation() {
    for (var i = 0; i < state?.preferredCandidateLocation?.length; i++) {
      existingPreferredJobLocation.push({
        label: state?.preferredCandidateLocation[i],
        value: state?.preferredCandidateLocation[i],
      });
    }
  }

  const initialState = {
    jobTitle: "",
    jobDescription: "",
    jobCompanyName: "",
    jobPostId: "",
    jobEndDate: "",
    attachment: "",
    industries: "",
    qualifications: "",
    preferredGender: "",
    designation: "",
    state: "",
    cities: "",
    ctc: "",
    experience: "",
    keySkill: "",
    preferredCandidateLocation: "",
    numberOfPositionOpen: "",
    remoteLocation: "",
    replacementMonth: "",
    minExperience: "",
    maxExperience: "",
    minCtc: "",
    maxCtc: "",
    emailReceivedDate: "",
    emailReceivedFileName: "",
    emailReceivedFromClient: "",
  };

  const [state, setState] = useState(useLocation().state);
  const [commissionType, setCommissionType] = useState(
    useLocation().state?.commissionType || "Percentage"
  );
  const [loginData, setLoginData] = useState({});
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [preferredCandidateLocation, setPjl] = useState([]);
  const [selectedDate, handleDateChange] = useState(new Date());
  const [selectedDateEmail, handleDateChangeEmail] = useState(null);

  const [jobTitle, setJobTitle] = useState(state?.jobTitle);
  // const [companyName, setCompanyName] = useState(state?.jobCompanyName)
  const [jobTitles, setJobTitles] = useState([]);
  const [jobTitleSuggestions, setJobTitleSuggestions] = useState([]);
  const [companyNames, setCompanyNames] = useState([]);
  // const [companySuggestions, setCompanySuggestions] = useState([])
  const [files, setFiles] = useState([]);
  const [filesEmail, setFilesEmail] = useState([]);
  const [jobDescription, setJobDescription] = useState([]);
  const [emailReceivedFromClient, setEmailReceivedFromClient] = useState("");
  const [countries, setCountries] = useState([]);

  let endDate = new Date();
  var emailDate = new Date();
  let existingKeySkill = [];
  let existingQualification = [];
  let existingIndustry = [];
  let existingPreferredJobLocation = [];

  const industryOptions = () => {
    return industries?.map((keys) => ({
      label: keys.industriesName,
      value: keys.industriesName,
    }));
  };

  const preferredJobLocationOptions = () => {
    return preferredCandidateLocation?.map((keys) => ({
      label: keys.preferredCandidateLocationName,
      value: keys.preferredCandidateLocationName,
    }));
  };

  const openDesciptionHandle = () => {
    document.getElementById("staticBackdrop").style.display = "block";
  };
  const openDesciptionHandle2 = () => {
    document.getElementById("staticBackdrop").style.display = "none";
  };
  const openEmailRecClientHandle = () => {
    document.getElementById("staticBackdropEmail").style.display = "block";
  };
  const openEmailRecClientHandle2 = () => {
    document.getElementById("staticBackdropEmail").style.display = "none";
  };
  if (!state) {
    setState(initialState);
  } else {
    changeEndDate();
    changeKeySkills();
    changeIndustry();
    changeQualifications();
    changePreferredLocation();
  }

  useEffect(() => {
    fetchCountries();
    if (history.location?.state?.emailReceivedDate) {
      let data = changeEmailDate(history.location?.state?.emailReceivedDate);
      handleDateChangeEmail(data);
    }
    window.scrollTo(0, 0);
    fetch(constants.ListJobTitlesUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setJobTitles(result.data);
      });
    fetch(constants.ListCompanyNamesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setCompanyNames(result.data);
      });
    fetch(constants.ListCitiesUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setCities(result);
      });
    fetch(constants.ListStatesUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setStates(result);
      });
    fetch(constants.ListIndustriesUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setIndustries(result);
      });
    fetch(constants.ListPreferredCandidateLocationsUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setPjl(result.data);
      });

    document.getElementById("datePicker").style.padding = "0px";
  }, []);

  const handleBlur = (e) => {
    if (e.target.value == "") {
      setError((prev) => ({
        ...prev,
        ["city"]: "Please Select city",
      }));
    } else {
      setError((prev) => ({
        ...prev,
        ["city"]: "",
      }));
    }
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
  };

  const handleTitleChange = (e) => {
    if (e.target.value == "") {
      setError((prev) => ({
        ...prev,
        ["jobTitle"]: "Please Select job Title",
      }));
    } else {
      setError((prev) => ({
        ...prev,
        ["jobTitle"]: "",
      }));
    }

    let matches = [];
    if (e.target.value) {
      matches = jobTitles?.filter((jobTitle) => {
        const regex = new RegExp(`${e.target.value}`, "gi");
        return jobTitle?.match(regex);
      });
    }
    setJobTitle(e.target.value);
    setJobTitleSuggestions(matches);
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
  };

  // const handleCompanyNameChange = (e) => {
  //    if (e.target.value == '') {
  //       setError(prev => ({
  //          ...prev,
  //          ['jobCompanyName']: 'Please Enter Company Name'
  //       }));
  //    }
  //    else {
  //       setError(prev => ({
  //          ...prev,
  //          ['jobCompanyName']: ''
  //       }));
  //    }

  //    let matches = [];
  //    if (e.target.value) {
  //       matches = companyNames?.filter((companyName) => {
  //          const regex = new RegExp(`${e.target.value}`, "gi");
  //          return companyName?.match(regex)
  //       })
  //    }
  //    setCompanyName(e.target.value)
  //    setCompanySuggestions(matches)
  //    const newLoginData = { ...loginData }
  //    newLoginData[e.target.name] = e.target.value
  //    setLoginData(newLoginData)
  // }

  const handleSuggestionClick = (title) => {
    setJobTitle(title);
    setJobTitleSuggestions([]);
    const newLoginData = { ...loginData };
    newLoginData["jobTitle"] = title;
    setLoginData(newLoginData);
  };

  // const handleCompanyNameSuggestionClick = (title) => {
  //    setCompanyName(title);
  //    setCompanySuggestions([])
  //    const newLoginData = { ...loginData }
  //    newLoginData["jobCompanyName"] = title
  //    setLoginData(newLoginData)
  // }

  const handleCountryChange = (e) => {
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
  };

  const handleStateChange = (e) => {
    if (e.target.value == "") {
      setError((prev) => ({
        ...prev,
        ["states"]: "Please Select state",
      }));
    } else {
      setError((prev) => ({
        ...prev,
        ["states"]: "",
      }));
    }

    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);

    fetch(`${constants.GetCityByStateNameUrl}/${e.target.value}`, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setCities(result.data);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const fetchCountries = async () => {
    try {
      fetch(constants.GetCountriesUrl, {
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          setCountries(result.data);
        });
    } catch (error) {
      console.error("Failed to fetch countries", error);
    }
  };

  const fetchStates = async (countryCode) => {
    try {
      fetch(`${constants.GetStatesUrl}/${countryCode}`, {
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          setStates(result.data);
          setCities([]);
        });
    } catch (error) {
      console.error("Failed to fetch states", error);
    }
  };

  // const handleKeySkills = (value) => {
  //    const newLoginData = { ...loginData }
  //    let keySkillChange = new Array();
  //    if (value) {
  //       for (var i = 0; i < value.length; i++) {
  //          keySkillChange.push(value[i].value.toString());
  //       }
  //       newLoginData["keySkills"] = keySkillChange
  //    }
  //    else {
  //       keySkillChange.length = 0;
  //       newLoginData["keySkills"] = keySkillChange
  //    }
  //    setLoginData(newLoginData)
  // }

  // const handleQualifications = (value) => {
  //    const newLoginData = { ...loginData }
  //    let qualificationChange = new Array();
  //    if (value) {
  //       for (var i = 0; i < value.length; i++) {
  //          qualificationChange.push(value[i].value.toString());
  //       }
  //       newLoginData["qualification"] = qualificationChange
  //    }
  //    else {
  //       qualificationChange.length = 0;
  //       newLoginData["qualification"] = qualificationChange
  //    }
  //    setLoginData(newLoginData)
  // }

  const handleIndustry = (value) => {
    const newLoginData = { ...loginData };
    let industryChange = new Array();
    if (value) {
      for (var i = 0; i < value.length; i++) {
        industryChange.push(value[i].value.toString());
      }
      newLoginData["industries"] = industryChange;
    } else {
      industryChange.length = 0;
      newLoginData["industries"] = industryChange;
    }
    setLoginData(newLoginData);
  };

  const onUpload = (e) => {
    let uploadFiles = e.target.files;
    setFiles(uploadFiles[0]);
  };
  const onUploadEmail = (e) => {
    let uploadFiles = e.target.files;
    setFilesEmail(uploadFiles[0]);
  };

  const handlePreferredJobLocation = (value) => {
    const newLoginData = { ...loginData };
    let preferredJobLocationChange = new Array();
    if (value) {
      for (var i = 0; i < value.length; i++) {
        preferredJobLocationChange.push(value[i].value.toString());
      }
      newLoginData["preferredCandidateLocation"] = preferredJobLocationChange;
    } else {
      preferredJobLocationChange.length = 0;
      newLoginData["preferredCandidateLocation"] = preferredJobLocationChange;
    }
    setLoginData(newLoginData);
  };

  const handleChangeDate = (value) => {
    handleDateChange(value);
    state.jobEndDate = value.toLocaleDateString();
    changeEndDate();
    const newLoginData = { ...loginData };
    newLoginData["jobEndDate"] = value.toLocaleDateString("en-GB");
    setLoginData(newLoginData);
  };
  const handleChangeDateEmail = (value) => {
    handleDateChangeEmail(value);
    emailDate = value;
    const newLoginData = { ...loginData };
    newLoginData["emailReceivedDate"] = value.toLocaleDateString("en-GB");
    setLoginData(newLoginData);
  };

  function removeHTML(str) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerHTML || "";
  }

  const handleEditorChange = (content, editor) => {
    document.getElementById("popupbox").innerHTML = `${removeHTML(content)}`;
    setJobDescription(content);
    if (content !== "" && content !== null) {
      const newLoginData = { ...loginData };
      newLoginData["jobDescription"] = content;
      setLoginData(newLoginData);
    }
  };

  const handleEditorEmailChange = (content, editor) => {
    document.getElementById("popupboxEmail").innerHTML = `${removeHTML(
      content
    )}`;
    setEmailReceivedFromClient(content);
    if (content !== "" && content !== null) {
      const newLoginData = { ...loginData };
      newLoginData["emailReceivedFromClient"] = content;
      setLoginData(newLoginData);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setIsSpin(true);
    if (questions.length <= 0) {
      toast.error("Please add at least one Assessment Question.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setIsSpin(false);
      return;
    }

    const fd1 = new FormData();
    fd1.append("jobDescription", files);
    const fd2 = new FormData();
    fd2.append("jobDescription", filesEmail);
    e.preventDefault();

    for (var i in loginData) {
      if (i === null) {
        delete loginData[i];
      }
    }

    loginData.minCtc = loginData?.minCtc && Number(loginData?.minCtc);
    loginData.maxCtc = loginData?.maxCtc && Number(loginData?.maxCtc);
    loginData.minExperience =
      loginData?.minExperience && Number(loginData?.minExperience);
    loginData.maxExperience =
      loginData?.maxExperience && Number(loginData?.maxExperience);
    loginData.commissionForJob =
      loginData?.commissionForJob && Number(loginData?.commissionForJob);
    loginData.numberOfPositionOpen =
      loginData?.numberOfPositionOpen &&
      Number(loginData?.numberOfPositionOpen);
    var url = state.jobPostId
      ? `${constants.AddJobUrl}/${state.jobPostId}`
      : constants.AddJobUrl;

    const payload = { ...loginData, assessment: questions, commissionType };

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          if (res?.error) {
            toast.error(`❌ ${res?.error?.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setIsSpin(false);
            }, 3000);
          } else if (files?.size && filesEmail?.size) {
            var tempState = state;
            var tempRes = res;
            fetch(
              state.jobPostId && state.jobDescriptionFileName
                ? `${constants.UpdateAttachmentUrl}/${state.jobDescriptionFileName}`
                : `${constants.UploadAttachmentUrl}/${
                    state.jobPostId || res.data.jobPostId
                  }`,
              {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${loggedInUser.sessionToken}`,
                },
                body: fd1,
              }
            )
              .then((response) => response.json())
              .then((res) => {
                if (res.message) {
                  fetch(
                    tempState.jobPostId && tempState.emailReceivedFileName
                      ? `${constants.UpdateAttachmentUrlEmail}/${tempState.emailReceivedFileName}`
                      : `${constants.UploadAttachmentUrlEmail}/${
                          tempState.jobPostId || tempRes.data.jobPostId
                        }`,
                    {
                      method: "POST",
                      headers: {
                        Authorization: `Bearer ${loggedInUser.sessionToken}`,
                      },
                      body: fd2,
                    }
                  )
                    .then((response) => response.json())
                    .then((res) => {
                      if (tempRes?.message) {
                        toast.success(
                          `✅ ${tempRes?.message?.messageDescription} !`,
                          {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          }
                        );
                        setTimeout(() => {
                          history.push("/list-job");
                        }, 3000);
                      } else {
                        if (res.error) {
                          toast.error(`❌ ${res.error.errorMessage} !`, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          });
                          setTimeout(() => {
                            setIsSpin(false);
                          }, 3000);
                        }
                      }
                    });
                } else {
                  if (res.error) {
                    toast.error(`❌ ${res.error.errorMessage} !`, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                    });
                    setTimeout(() => {
                      setIsSpin(false);
                    }, 3000);
                  }
                }
              });
          } else if (files?.size) {
            fetch(
              state.jobPostId && state.jobDescriptionFileName
                ? `${constants.UpdateAttachmentUrl}/${state.jobDescriptionFileName}`
                : `${constants.UploadAttachmentUrl}/${
                    state.jobPostId || res.data.jobPostId
                  }`,
              {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${loggedInUser.sessionToken}`,
                },
                body: fd1,
              }
            )
              .then((response) => response.json())
              .then((res) => {
                if (tempRes?.message) {
                  toast.success(
                    `✅ ${tempRes?.message?.messageDescription} !`,
                    {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                    }
                  );
                  setTimeout(() => {
                    history.push("/list-job");
                  }, 3000);
                } else {
                  if (res.error) {
                    toast.error(`${res.error.errorMessage} !`, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                    });
                    setTimeout(() => {
                      setIsSpin(false);
                    }, 3000);
                  }
                }
              });
          } else if (filesEmail?.size) {
            fetch(
              state.jobPostId && state.emailReceivedFileName
                ? `${constants.UpdateAttachmentUrlEmail}/${state.emailReceivedFileName}`
                : `${constants.UploadAttachmentUrlEmail}/${
                    state.jobPostId || res.data.jobPostId
                  }`,
              {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${loggedInUser.sessionToken}`,
                },
                body: fd2,
              }
            )
              .then((response) => response.json())
              .then((res) => {
                if (tempRes?.message) {
                  toast.success(`${tempRes?.message?.messageDescription} !`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  });
                  setTimeout(() => {
                    history.push("/list-job");
                  }, 3000);
                } else {
                  if (res.error) {
                    toast.error(`${res?.error?.errorMessage} !`, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                    });
                    setTimeout(() => {
                      setIsSpin(false);
                    }, 3000);
                  }
                }
              });
          } else if (loginData?.jobCompanyName && loginData?.jobTitle) {
            // && state.jobDescription && state.designation && state.preferredGender && state.experience && state.qualification && state.keySkill && state.ctc && state.industries && state.states && state.city && state.remoteLocation && state.jobEndDate && state.numberOfPositionOpen && state.commissionForJob && state.preferredCandidateLocation
            // else if (res.message) {

            toast.success(`${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              history.push("/list-job");
            }, 3000);
          } else {
            if (res?.error?.errorCode) {
              toast.error(`${res.error.errorMessage} !`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });

              setTimeout(() => {
                setIsSpin(false);
              }, 3000);
            } else {
              toast.success(`${res.message.messageDescription} !`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });

              setTimeout(() => {
                history.push("/list-job");
                setIsSpin(false);
              }, 3000);
            }
          }
        }
      })
      .catch((error) => {
        setIsSpin(false);
        toast.error(`Please try after some time`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  //validation

  // const submitHandler = async (e) => {
  //   e.preventDefault();
  //   setIsSpin(true);

  //   var formDataFile = new FormData();
  //   formDataFile.append("jobDescription", files);

  //   var formDataEmail = new FormData();
  //   formDataEmail.append("jobDescription", filesEmail);

  //   // Clean up `loginData` to remove null/undefined fields and ensure numeric conversions
  //   const cleanData = {
  //     ...loginData,
  //     minCtc: loginData?.minCtc && Number(loginData?.minCtc),
  //     maxCtc: loginData?.maxCtc && Number(loginData?.maxCtc),
  //     minExperience: loginData?.minExperience && Number(loginData?.minExperience),
  //     maxExperience: loginData?.maxExperience && Number(loginData?.maxExperience),
  //     commissionForJob: loginData?.commissionForJob && Number(loginData?.commissionForJob),
  //     numberOfPositionOpen: loginData?.numberOfPositionOpen && Number(loginData?.numberOfPositionOpen),
  //   };

  //   const payload = { ...cleanData, assessment: questions };
  //   const url = state.jobPostId
  //     ? `${constants.AddJobUrl}/${state.jobPostId}`
  //     : constants.AddJobUrl;

  //   try {
  //     // Submit main payload
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${loggedInUser.sessionToken}`,
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     const result = await response.json();

  //     if (result.error) {
  //       toast.error(`❌ ${result.error.errorMessage}`, {
  //         position: "top-right",
  //         autoClose: 5000,
  //       });
  //       setIsSpin(false);
  //       return;
  //     }

  //     // Handle file uploads if applicable
  //     // if (files?.size || filesEmail?.size) {
  //     //   await handleFileUploads(result.data?.jobPostId || state.jobPostId);
  //     // }

  //     toast.success(`✅ ${result.message?.messageDescription}`, {
  //       position: "top-right",
  //       autoClose: 5000,
  //     });

  //     setTimeout(() => {
  //       history.push("/list-job");
  //     }, 3000);
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     toast.error("❌ Something went wrong, please try again.", {
  //       position: "top-right",
  //       autoClose: 5000,
  //     });
  //   } finally {
  //     setIsSpin(false);
  //   }
  // };

  // Helper function to handle file uploads
  // const handleFileUploads = async (jobPostId) => {
  //   const fileUploadPromises = [];

  //   if (files?.size) {
  //     const fileUploadUrl = state.jobPostId && state.jobDescriptionFileName
  //       ? `${constants.UpdateAttachmentUrl}/${state.jobDescriptionFileName}`
  //       : `${constants.UploadAttachmentUrl}/${jobPostId}`;

  //     fileUploadPromises.push(
  //       fetch(fileUploadUrl, {
  //         method: "POST",
  //         headers: { Authorization: `Bearer ${loggedInUser.sessionToken}` },
  //         body: formDataFile,
  //       }).then((res) => res.json())
  //     );
  //   }

  //   if (filesEmail?.size) {
  //     const emailUploadUrl = state.jobPostId && state.emailReceivedFileName
  //       ? `${constants.UpdateAttachmentUrlEmail}/${state.emailReceivedFileName}`
  //       : `${constants.UploadAttachmentUrlEmail}/${jobPostId}`;

  //     fileUploadPromises.push(
  //       fetch(emailUploadUrl, {
  //         method: "POST",
  //         headers: { Authorization: `Bearer ${loggedInUser.sessionToken}` },
  //         body: formDataEmail,
  //       }).then((res) => res.json())
  //     );
  //   }

  //   const uploadResults = await Promise.all(fileUploadPromises);

  //   uploadResults.forEach((res) => {
  //     if (res.error) {
  //       toast.error(`❌ ${res.error.errorMessage}`, {
  //         position: "top-right",
  //         autoClose: 5000,
  //       });
  //     }
  //   });
  // };

  const [input, setInput] = useState({
    jobCompanyName: "",
    jobTitle: "",
    jobDescription: "",
    designation: "",
    preferredGender: "",
    experience: "",
    qualification: "",
    keySkills: "",
    ctc: "",
    commissionForJob: "",
    numberOfPositionOpen: "",
  });
  const [error, setError] = useState({
    jobCompanyName: "",
    jobTitle: "",
    jobDescription: "",
    designation: "",
    preferredGender: "",
    // experience: '',
    minExperience: "",
    maxExperience: "",
    qualification: "",
    keySkills: "",
    // ctc: '',
    minCtc: "",
    maxCtc: "",
    commissionForJob: "",
    numberOfPositionOpen: "",
    states: "",
    city: "",
  });
  const onInputChange = (e) => {
    const { name, value } = e.target;
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
    validateInput(e);
  };
  const validateInput = (e) => {
    let { name, value } = e.target;
    setError((prev) => {
      const stateObj = { ...prev, [name]: "" };
      switch (name) {
        case "jobCompanyName":
          if (!value) {
            stateObj[name] = "Please Enter Company Name.";
          }
          if (value) {
            stateObj[name] =
              [/[a-zA-Z]+/].every((pattern) => pattern.test(value)) ||
              "Invalid Company Name";
          }
          break;
        case "jobTitle":
          if (!value) {
            stateObj[name] = "Please enter job title:";
          }
        case "jobDescription":
          if (!value) {
            stateObj[name] = "Please enter job description:";
          }
        case "preferredGender":
          if (!value) {
            stateObj[name] = "Please enter gender:";
          }

        case "designation":
          if (!value) {
            stateObj[name] = "please enter designation";
          }
          if (value) {
            stateObj[name] =
              [/[a-zA-Z]+/].every((pattern) => pattern.test(value)) ||
              "Invalid Designation";
          }
          break;
        case "qualification":
          if (!value) {
            stateObj[name] = "please enter Qualification";
          }
          if (value) {
            stateObj[name] =
              [/[a-zA-Z]+/].every((pattern) => pattern.test(value)) ||
              "Invalid Qualification";
          }
          break;
        case "minExperience":
          if (!value) {
            stateObj[name] = "please enter min-experience";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid min-experience";
          }
          break;
        case "maxExperience":
          if (!value) {
            stateObj[name] = "please enter max-experience";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid max-experience";
          }

          break;
        case "keySkills":
          if (!value) {
            stateObj[name] = "please enter keyskills";
          }
          if (value) {
            stateObj[name] =
              [/[a-zA-Z]+/].every((pattern) => pattern.test(value)) ||
              "Invalid keyskills";
          }
          break;
        case "minCtc":
          if (!value) {
            stateObj[name] = "please enter min-ctc";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid min-ctc";
            if (Number(value) > 10000) {
              stateObj[name] = "please enter in LPA";
            }
          }
          break;
        case "maxCtc":
          if (!value) {
            stateObj[name] = "please enter max-ctc";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid max-ctc";

            if (Number(value) > 10000) {
              stateObj[name] = "please enter in LPA";
            }
          }
          break;
        case "numberOfPositionOpen":
          if (!value) {
            stateObj[name] = "please enter open";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid open position";
          }
          break;
        case "commissionForJob":
          if (!value) {
            stateObj[name] = "Please Enter commission.";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid commission";
          }
          break;
        default:
          break;
      }
      return stateObj;
    });
  };

  const [questions, setQuestions] = useState(
    state?.assessment ? state?.assessment : []
  );
  const [newQuestion, setNewQuestion] = useState("");
  const [newOptions, setNewOptions] = useState([]);
  const [newOptionText, setNewOptionText] = useState("");

  //   const onInputChange = (e) => {
  //    const { name, value } = e.target;
  //    setState((prev) => ({ ...prev, [name]: value }));
  //  };

  // const validateInput = (e) => {
  //    const { name, value } = e.target;
  //    if (name === "keySkills" && value.trim() === "") {
  //      setError((prev) => ({ ...prev, [name]: "Key Skills is required." }));
  //    } else {
  //      setError((prev) => ({ ...prev, [name]: "" }));
  //    }
  //  };

  const handleAddOption = () => {
    if (newOptionText.trim() !== "") {
      setNewOptions((prev) => [...prev, newOptionText]);
      setNewOptionText("");
    }
  };

  const handleSaveQuestion = () => {
    if (questions.length >= 10) {
      toast.error("You can't add more than 5 Questions.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    } else if (newQuestion.trim() !== "") {
      const staticOptions = [1, 2, 3, 4, 5];
      const newQuestionObj = {
        id: questions.length + 1,
        question: newQuestion,
        // options: staticOptions,
        rating: "",
        comment: "",
      };
      setQuestions((prev) => [...prev, newQuestionObj]);
      setNewQuestion("");
      setNewOptions([]);
    } else {
      toast.error("Please provide a valid question and at least one option.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      // alert("Please provide a valid question and at least one option.");
    }
  };

  const handleRemoveQuestion = (id) => {
    setQuestions((prev) => prev.filter((q) => q.id !== id));
  };

  const handleOptionChange = (questionId, option) => {
    setQuestions((prev) =>
      prev.map((q) =>
        q.id === questionId ? { ...q, selectedOption: option } : q
      )
    );
  };

  return (
    <Fragment>
      {/* <PageTitle activeMenu="Validation" motherMenu="Form" /> */}
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add Job</h4>
            </div>
            <div className="card-body">
              <div className="form-validation">
                <form
                  className="form-valide"
                  action="#"
                  method="post"
                  onSubmit={(e) => submitHandler(e)}
                >
                  {/* firstcolumn  */}
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="form-group row ">
                        <label
                          className="col-lg-4 Description-Label"
                          htmlFor="val-username"
                        >
                          Job Title
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            minLength="3"
                            // className="form-control Color-box"
                            className={
                              error?.jobTitle
                                ? "form-control Color-box is-invalid"
                                : "form-control Color-box "
                            }
                            name="jobTitle"
                            placeholder="Enter a job title.."
                            defaultValue={state?.jobTitle}
                            onChange={(e) => handleTitleChange(e)}
                            value={jobTitle}
                            onBlur={() => {
                              setTimeout(() => {
                                setJobTitleSuggestions([]);
                              }, 100);
                            }}
                          />
                          {error.jobTitle && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.jobTitle}
                            </span>
                          )}
                          <ul
                            className="card col-lg-12"
                            style={{ left: 0, position: "absolute" }}
                          >
                            {jobTitleSuggestions?.length > 0 &&
                              jobTitleSuggestions?.map((suggestion, i) => (
                                <>
                                  <li
                                    key={i}
                                    style={{ listStyle: "none" }}
                                    className="suggestions-div"
                                    onMouseDown={() =>
                                      handleSuggestionClick(suggestion)
                                    }
                                  >
                                    <div>{suggestion}</div>
                                  </li>
                                </>
                              ))}
                          </ul>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          //  className="col-lg-4 col-form-label"
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-skill"
                        >
                          Company Name
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            name="jobCompanyName"
                            onChange={handleBlur}
                            className="form-control Color-box"
                          >
                            <option value=" ">Select Company Names</option>
                            {companyNames?.map((key) => (
                              <option
                                selected={
                                  state?.jobCompanyName === key.companyName
                                    ? "selected"
                                    : ""
                                }
                                value={key.companyName}
                              >
                                {key.companyName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-lg-4 Description-Label">
                          Job Description{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <div className="">
                            <textarea
                              id="popupbox"
                              name="jobDescription"
                              onClick={openDesciptionHandle}
                              className=" form-control Color-box"
                              onChange={onInputChange}
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              placeholder="Click here for Job Description"
                            >
                              {/* Click here for Job Description */}
                            </textarea>
                            <div
                              className="modal fade show"
                              id="staticBackdrop"
                              data-bs-backdrop="static"
                              data-bs-keyboard="false"
                              tabIndex="-1"
                              aria-labelledby="staticBackdropLabel"
                              aria-hidden="true"
                            >
                              <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5
                                      className="modal-title"
                                      id="staticBackdropLabel"
                                    >
                                      Job Description
                                    </h5>
                                    <button
                                      type="button"
                                      onClick={openDesciptionHandle2}
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <svg
                                        focusable="false"
                                        aria-hidden="true"
                                        fill="#00ADEE"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
                                        <path
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                        ></path>
                                      </svg>
                                    </button>
                                  </div>
                                  <div className="modal-body poptextbox-size">
                                    <Editor
                                      apiKey="iug8olfbamqnf5w6itk1ui4rtsstd6gncjmddsk0jgvgahxr"
                                      initialValue={`<p>${state?.jobDescription}</p>`}
                                      init={{
                                        height: 250,
                                        menubar: false,
                                        plugins: [
                                          "advlist autolink lists link image code charmap print preview anchor",
                                          "searchreplace visualblocks code fullscreen",
                                          "insertdatetime media table paste code help wordcount",
                                        ],
                                        toolbar:
                                          "undo redo | formatselect | bold italic backcolor | \
                                                               alignleft aligncenter alignright alignjustify | \
                                                               bullist numlist outdent indent | removeformat | help ",
                                      }}
                                      onEditorChange={handleEditorChange}
                                    />
                                  </div>

                                  <div className="modal-footer">
                                    <div className="form-group row">
                                      <label
                                        className="col-lg-12 col-form-label Description-Label"
                                        htmlFor="Existing Attachment"
                                      >
                                        Existing Attachment:
                                      </label>
                                      <label
                                        className="col-lg-6"
                                        style={{ marginTop: 6 }}
                                      >
                                        <a
                                          style={{
                                            cursor:
                                              state?.jobDescriptionFileName
                                                ? "pointer"
                                                : "initial",
                                            color: state?.jobDescriptionFileName
                                              ? "#00ADEE"
                                              : "initial",
                                          }}
                                          onClick={() =>
                                            handleDownloadResume(
                                              state?.jobDescriptionFileName
                                            )
                                          }
                                        >
                                          {state?.jobDescriptionFileName ||
                                            "None"}
                                        </a>
                                      </label>
                                    </div>
                                    <input
                                      type="file"
                                      name="file"
                                      id="fileResume"
                                      onChange={(e) => onUpload(e)}
                                      defaultValue={state?.attachment}
                                    />
                                    <button
                                      type="button"
                                      onClick={openDesciptionHandle2}
                                      className="btn btn-primary"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-lg-4 Description-Label">
                          Email received From Client{""}
                        </label>
                        <div className="col-lg-6">
                          <div className="">
                            <textarea
                              id="popupboxEmail"
                              name="jobDescription"
                              onClick={openEmailRecClientHandle}
                              className=" form-control Color-box"
                              onChange={onInputChange}
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              placeholder="Click here for Email received From Client"
                            >
                              {/* Click here for Job Description */}
                            </textarea>
                            <div
                              className="modal fade show"
                              id="staticBackdropEmail"
                              data-bs-backdrop="static"
                              data-bs-keyboard="false"
                              tabIndex="-1"
                              aria-labelledby="staticBackdropLabel"
                              aria-hidden="true"
                            >
                              <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5
                                      className="modal-title"
                                      id="staticBackdropLabelEmail"
                                    >
                                      Email Received From Client
                                    </h5>
                                    <button
                                      type="button"
                                      onClick={openEmailRecClientHandle2}
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <svg
                                        focusable="false"
                                        aria-hidden="true"
                                        fill="#00ADEE"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
                                        <path
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                        ></path>
                                      </svg>
                                    </button>
                                  </div>
                                  <div className="modal-body poptextbox-size">
                                    <Editor
                                      initialValue={`<p>${
                                        state?.emailReceivedFromClient || ""
                                      }</p>`}
                                      init={{
                                        height: 250,
                                        menubar: false,
                                        plugins: [
                                          "advlist autolink lists link image code charmap print preview anchor",
                                          "searchreplace visualblocks code fullscreen",
                                          "insertdatetime media table paste code help wordcount",
                                        ],
                                        toolbar:
                                          "undo redo | formatselect | bold italic backcolor | \
                                                               alignleft aligncenter alignright alignjustify | \
                                                               bullist numlist outdent indent | removeformat | help ",
                                      }}
                                      onEditorChange={handleEditorEmailChange}
                                    />
                                  </div>

                                  <div className="modal-footer">
                                    <div className="form-group row">
                                      <label
                                        className="col-lg-12 col-form-label Description-Label"
                                        htmlFor="Existing Attachment"
                                      >
                                        Existing Attachment:
                                      </label>
                                      <label
                                        className="col-lg-6"
                                        style={{ marginTop: 6 }}
                                      >
                                        <a
                                          style={{
                                            cursor: state?.emailReceivedFileName
                                              ? "pointer"
                                              : "initial",
                                            color: state?.emailReceivedFileName
                                              ? "#00ADEE"
                                              : "initial",
                                          }}
                                          onClick={() =>
                                            handleDownloadEmail(
                                              state?.emailReceivedFileName
                                            )
                                          }
                                        >
                                          {state?.emailReceivedFileName ||
                                            "None"}
                                        </a>
                                      </label>
                                    </div>
                                    <input
                                      type="file"
                                      name="file"
                                      id="fileResume"
                                      onChange={(e) => onUploadEmail(e)}
                                      defaultValue={state?.attachment}
                                    />
                                    <button
                                      type="button"
                                      onClick={openEmailRecClientHandle2}
                                      className="btn btn-primary"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Email Received Date{""}
                        </label>
                        <div className="col-lg-6">
                          <div className="form-control Color-box">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                autoOk
                                id="datePicker1"
                                name="jobEndDate1"
                                label=""
                                clearable
                                format="dd/MM/yyyy"
                                value={selectedDateEmail}
                                onChange={handleChangeDateEmail}
                              />
                            </MuiPickersUtilsProvider>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label Description-Label">
                          Preferred Gender{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6 col-form-label">
                          <input
                            type="radio"
                            defaultChecked={
                              state?.preferredGender === "male"
                                ? state?.preferredGender
                                : ""
                            }
                            value="male"
                            name="preferredGender"
                            onChange={handleBlur}
                          />{" "}
                          Male<br></br>
                          <input
                            type="radio"
                            defaultChecked={
                              state?.preferredGender === "female"
                                ? state?.preferredGender
                                : ""
                            }
                            value="female"
                            name="preferredGender"
                            onChange={handleBlur}
                          />{" "}
                          Female<br></br>
                          <input
                            type="radio"
                            defaultChecked={
                              state?.preferredGender === "both"
                                ? state?.preferredGender
                                : ""
                            }
                            value="both"
                            name="preferredGender"
                            onChange={handleBlur}
                          />{" "}
                          Both
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-website"
                        >
                          Min Experience (in year)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            name="minExperience"
                            defaultValue={state?.minExperience}
                            placeholder="Minimum Experience"
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.minExperience.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                          />
                          {error.minExperience && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.minExperience}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-website"
                        >
                          Max Experience (in year)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            name="maxExperience"
                            defaultValue={state?.maxExperience}
                            placeholder="Maximum Experience"
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.maxExperience.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                          />
                          {error.maxExperience && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.maxExperience}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-password"
                        >
                          Preferred Qualification
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            name="qualification"
                            defaultValue={state?.qualification}
                            placeholder="Qualification"
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.qualification.length > 0
                                ? "is-invalid form-control"
                                : "form-control Color-box"
                            }
                          />
                          {error.qualification && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.qualification}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-phoneus"
                        >
                          Key Skills
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            name="keySkills"
                            defaultValue={state?.keySkills}
                            placeholder="KeySkills"
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.keySkills.length > 0
                                ? "is-invalid form-control"
                                : "form-control Color-box"
                            }
                          />
                          {error.keySkills && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.keySkills}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-confirm-password"
                        >
                          Min CTC(LPA){""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            max="1000"
                            name="minCtc"
                            defaultValue={state?.minCtc}
                            placeholder="Minimum Ctc"
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.minCtc.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                          />
                          {error.minCtc && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.minCtc}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-confirm-password"
                        >
                          Max CTC(LPA){""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            max="1000"
                            name="maxCtc"
                            defaultValue={state?.maxCtc}
                            placeholder="Maximum Ctc"
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.maxCtc.length > 0
                                ? "noscroll is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                          />
                          {error.maxCtc && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.maxCtc}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* 2ndcolumn */}
                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Industries{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <Select
                            closeMenuOnSelect={false}
                            components={{ ClearIndicator }}
                            styles={{ clearIndicator: ClearIndicatorStyles }}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "25px",
                              colors: {
                                ...theme.colors,
                                text: "#00ADEE",
                                primary25: "#00ADEE",
                                primary: "#00ADEE",
                                neutral20: "#00ADEE",
                              },
                            })}
                            defaultValue={[...existingIndustry]}
                            isMulti
                            options={industryOptions()}
                            onChange={(value) => {
                              handleIndustry(value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label Description-Label">
                          Designation{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            name="designation"
                            defaultValue={state?.designation}
                            placeholder="Designation"
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.designation.length > 0
                                ? "is-invalid form-control"
                                : "form-control Color-box"
                            }
                          />
                          {error.designation && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.designation}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Country{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            name="country"
                            onChange={(e) => {
                              handleCountryChange(e);
                              setStates([]);
                              fetchStates(e.target.value);
                            }}
                            // className="form-control Color-box"
                            className={
                              error?.states
                                ? "form-control Color-box is-invalid"
                                : "form-control Color-box "
                            }
                          >
                            <option value="">Please select</option>
                            {countries?.map((country) => (
                              <option
                                selected={
                                  state?.country === country.countryName
                                    ? "selected"
                                    : ""
                                }
                                value={country.countryName}
                              >
                                {country.countryName}
                              </option>
                            ))}
                          </select>
                          {error.countries && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.countries}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          State{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            name="state"
                            onChange={handleStateChange}
                            // className="form-control Color-box"
                            className={
                              error?.states
                                ? "form-control Color-box is-invalid"
                                : "form-control Color-box "
                            }
                          >
                            <option value="">Please select</option>
                            {states?.map((states) => (
                              <option
                                selected={
                                  state?.state === states.stateName
                                    ? "selected"
                                    : ""
                                }
                                value={states.stateName}
                              >
                                {states.stateName}
                              </option>
                            ))}
                          </select>
                          {error.states && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.states}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          City <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            name="city"
                            onChange={handleBlur}
                            // className="form-control Color-box"
                            className={
                              error?.city
                                ? "form-control Color-box is-invalid"
                                : "form-control Color-box "
                            }
                          >
                            <option value="">Please select</option>
                            {cities?.map((city) => (
                              <option
                                selected={
                                  state?.city === city.cityName
                                    ? "selected"
                                    : ""
                                }
                                value={city.cityName}
                              >
                                {city.cityName}
                              </option>
                            ))}
                          </select>
                          {error.city && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.city}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label Description-Label">
                          Work Type{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6 col-form-label">
                          <input
                            type="radio"
                            defaultChecked={
                              state?.remoteLocation === "wfh"
                                ? state?.remoteLocation
                                : ""
                            }
                            value="wfh"
                            name="remoteLocation"
                            onChange={handleBlur}
                          />{" "}
                          WFH<br></br>
                          <input
                            type="radio"
                            defaultChecked={
                              state?.remoteLocation === "office"
                                ? state?.remoteLocation
                                : ""
                            }
                            value="office"
                            name="remoteLocation"
                            onChange={handleBlur}
                          />{" "}
                          Office<br></br>
                          <input
                            type="radio"
                            defaultChecked={
                              state?.remoteLocation === "hybrid"
                                ? state?.remoteLocation
                                : ""
                            }
                            value="hybrid"
                            name="remoteLocation"
                            onChange={handleBlur}
                          />{" "}
                          Hybrid
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Job End Date{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <div className="form-control Color-box">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                autoOk
                                id="datePicker"
                                name="jobEndDate"
                                label=""
                                clearable
                                format="dd/MM/yyyy"
                                disablePast
                                value={
                                  state?.jobEndDate
                                    ? endDate
                                    : selectedDate.toLocaleDateString()
                                }
                                onChange={handleChangeDate}
                              />
                            </MuiPickersUtilsProvider>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-digits"
                        >
                          Number of Open Position{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            name="numberOfPositionOpen"
                            min="0"
                            placeholder="Number of open Positions"
                            defaultValue={state?.numberOfPositionOpen}
                            className={
                              error.numberOfPositionOpen.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          {error.numberOfPositionOpen && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.numberOfPositionOpen}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Commission for Job(%){""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            defaultValue={state?.commissionForJob}
                            name="commissionForJob"
                            placeholder="Enter Commission for Job.."
                            className={
                              error.commissionForJob.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          {error.commissionForJob && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.commissionForJob}
                            </span>
                          )}
                        </div>
                      </div> */}

                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label Description-Label">
                          Commission for Job{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6 d-flex">
                          <input
                            type="number"
                            min="0"
                            defaultValue={state?.commissionForJob}
                            name="commissionForJob"
                            placeholder="Enter Commission for Job..."
                            className={`form-control noscroll ${
                              error.commissionForJob.length > 0
                                ? "is-invalid"
                                : "Color-box"
                            }`}
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          <select
                            className="form-control Color-box ml-3"
                            value={commissionType}
                            onChange={(e) => setCommissionType(e.target.value)}
                            style={{ maxWidth: "100px" }}
                          >
                            <option value="Percentage">%</option>
                            <option value="Amount">Amount</option>
                          </select>
                        </div>
                        {error.commissionForJob && (
                          <span
                            className="text-danger ml-2"
                            style={{ fontSize: "13px" }}
                          >
                            {error.commissionForJob}
                          </span>
                        )}
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Preferred Candidate Location{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <Select
                            closeMenuOnSelect={false}
                            components={{ ClearIndicator }}
                            styles={{ clearIndicator: ClearIndicatorStyles }}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "25px",
                              colors: {
                                ...theme.colors,
                                text: "#00ADEE",
                                primary25: "#00ADEE",
                                primary: "#00ADEE",
                                neutral20: "#00ADEE",
                              },
                            })}
                            defaultValue={[...existingPreferredJobLocation]}
                            isMulti
                            options={preferredJobLocationOptions()}
                            onChange={(value) => {
                              handlePreferredJobLocation(value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <h4>
                          Add New Assessment Question{" "}
                          <span className="text-danger">*</span>
                        </h4>
                        <div>
                          <input
                            type="text"
                            placeholder="Enter question"
                            value={newQuestion}
                            onChange={(e) => setNewQuestion(e.target.value)}
                            className="form-control mb-2"
                          />
                          {/* <div className="input-group mb-1">
                            <input
                              type="text"
                              placeholder="Enter option"
                              value={newOptionText}
                              onChange={(e) => setNewOptionText(e.target.value)}
                              className="form-control"
                            />
                            <button
                              type="button"
                              onClick={handleAddOption}
                              className="btn btn-primary"
                            >
                              Add Option
                            </button>
                          </div> */}
                          <ul className="ml-3 mb-3">
                            {newOptions.map((option, index) => (
                              <li key={index}>{option}</li>
                            ))}
                          </ul>
                          <button
                            type="button"
                            onClick={handleSaveQuestion}
                            className="btn btn-success"
                          >
                            Save Question
                          </button>
                        </div>
                      </div>

                      {/* Render Existing Questions */}
                      {questions?.length > 0 && (
                        <div className="form-group">
                          <h4>Existing Assessment Questions</h4>
                          {questions.map((question) => (
                            <div
                              key={question.id}
                              className="border p-3 rounded"
                            >
                              <p>
                                <strong>{question.question}</strong>
                              </p>
                              {/* <ul style={{ marginLeft: "20px" }}>
                                {question.options.map((option, index) => (
                                  <li key={index}>{option}</li>
                                ))}
                              </ul> */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleRemoveQuestion(question.id)
                                  }
                                  className="btn btn-danger"
                                >
                                  Remove Question
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* <div className="form-group">
                        <h4>Assessment Questions</h4>
                        {questions.map((question) => (
                          <div key={question.id} className="mb-3">
                            <p>{question.question}</p>
                            {question.options.map((option, index) => (
                              <label
                                key={index}
                                style={{ marginRight: "10px" }}
                              >
                                <input
                                  type="radio"
                                  name={`question-${question.id}`}
                                  value={option}
                                  checked={question.selectedOption === option}
                                  onChange={() =>
                                    handleOptionChange(question.id, option)
                                  }
                                />{" "}
                                {option}
                              </label>
                            ))}
                          </div>
                        ))}
                      </div> */}

                      <div className="form-group row">
                        <div className="col-lg-12 ml-auto">
                          {isSpin ? (
                            <button
                              type="button"
                              className="btn bg-white text-primary btn-block"
                            >
                              <CircularProgress
                                color="inherit"
                                size={24}
                                sx={{
                                  color: "green",
                                }}
                              />
                            </button>
                          ) : (
                            <button
                              style={{
                                border: "none",
                                backgroundColor: "#00ADEE",
                                marginTop: 21,
                                marginBottom: 21,
                              }}
                              type="submit"
                              className="btn btn-primary"
                              onClick={(e) => submitHandler(e)}
                            >
                              Submit
                            </button>
                          )}
                          &nbsp;&nbsp;
                          <button
                            style={{
                              border: "none",
                              backgroundColor: "#00ADEE",
                              marginTop: 21,
                              marginBottom: 21,
                            }}
                            type="submit"
                            className="btn btn-primary"
                            onClick={clearFilter}
                          >
                            Reset
                          </button>
                          <ToastContainer />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default PostJob;
